// Başka belgeden kalem aktarma penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'documents.copyItems';

export const copyItemsGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Başka belgeden kalem nasıl aktarılır?'),
  intro: t(`${G}.intro`, 'Daha önce hazırladığınız bir belgenin kalemlerini, ürünleri tek tek eklemeden açık olan forma kopyalarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Taraf, arama ve belge listesi'),
    footer: t(`${G}.regions.footer`, 'Ekle / Değiştir'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu pencere ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Formdaki belgeyle aynı türdeki belgeleri listeler: faturadayken faturaları, teklifteyken teklifleri, siparişteyken siparişleri, irsaliyedeyken irsaliyeleri. Seçtiğiniz belgenin kalemleri forma kopyalanır; kaynak belge değişmez ve kopyalanan kalemlerin onunla bağı kalmaz.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Tarafı seçin ve arayın'),
      text: t(`${G}.s2.text`, '"Verilen (Satış)" veya "Alınan (Alış)" ile hangi taraftaki belgelerin listeleneceğini seçin; pencere formun tarafıyla açılır. Arama kutusuna belge no veya cari adı yazın. Teklif ve siparişte ayrıca Durum filtresi vardır.'),
      tips: [
        t(`${G}.s2.tip1`, 'İrsaliyede taraf seçimi yoktur; yalnız satış irsaliyeleri listelenir.'),
        t(`${G}.s2.tip2`, 'Düzenlemekte olduğunuz belgenin kendisi listede görünmez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Belgeyi seçin'),
      text: t(`${G}.s3.text`, 'Listede bir satıra tıklayarak belgeyi seçin. Satırda belge no, tarih, cari, KDV dahil tutar ve durum görünür; en yeni belgeler üstte yer alır.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Kalemleri ekleyin veya değiştirin'),
      text: t(`${G}.s4.text`, '"Kalemlere Ekle", seçilen belgenin kalemlerini formdaki kalemlerin sonuna ekler. "Mevcut Kalemleri Değiştir", formdaki tüm kalemleri siler ve yerine seçilen belgenin kalemlerini koyar; bunun için onayınız istenir. "İptal" hiçbir şey yapmadan kapatır.'),
      tips: [
        t(`${G}.s4.tip1`, 'Miktar, fiyat, KDV, iskonto ve depo kaynak belgedeki gibi gelir; kaydetmeden önce kontrol edin.'),
        t(`${G}.s4.tip2`, 'Kopyalama yalnız formu doldurur; stok ve cari, belgeyi kaydettiğinizde işlenir.'),
        t(`${G}.s4.tip3`, 'Seçilen belgede kalem yoksa "Seçilen belgede kalem bulunmuyor." uyarısı çıkar.'),
      ],
    },
  ],
});
